export const GAME_TITLE = '윷놀이 대난투';
export const GAME_SHORT_TITLE = '윷난투';
